var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Full-calendar',{ref:"calendar-api",staticClass:"calendar",class:{ 'calendar-all': _vm.calendar },attrs:{"options":_vm.calendarOptions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }